import styled from 'styled-components';
import { BoldText, flexBox, translucentText } from 'styles/mixins';
import { CommonWrapper } from 'styles/common/Layout';

export const Background = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.primary.main};
  position: sticky;
  z-index: 2;
  top: ${({ theme }) => theme.config.headerHeight};
  padding: 16px 0 16px 0;
`;

export const Layout = styled(CommonWrapper)`
  width: 100%;
  ${flexBox('row', 'space-between', 'center')};

  .earth {
    width: 50%;
    max-width: 170px;
    height: auto;
    margin-bottom: 6px;
  }
`;

export const TextWrapper = styled.div`
  ${flexBox('column', 'center', 'flex-start')};

  span {
    margin-bottom: 3px;
  }

  .label {
    ${translucentText('#fff', '14px')};
    margin-bottom: 0.5em;
  }

  .value {
    color: #fff;
    font-size: 14px;
    display: inline-block;
    width: 100%;
    text-align: right;
  }

  .value-wrapper {
    width: max-content;
    ${flexBox('row', 'flex-start', 'center', '25px')};
    margin-top: 12px;

    > div {
      ${flexBox('column', 'center', 'flex-start')};
    }
  }

  .user-name {
    ${BoldText('#fff')};
  }

  button {
    margin-top: 12px;
    font-size: 12px;
    font-weight: 500;
  }
`;
